import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { BaseModalComponent } from '../../ui-components/modal/base-modal-component';
import { CloseBtnComponent } from '../../@components/close-btn/close-btn.component';
import { SharedModule } from '../../ui-components/shared.module';
import { TranslatePipe } from '@ngx-translate/core';
import { CircleUserIconComponent } from '../../../@icons/circle-user-icon.component';
import { MessageIconComponent } from '../../../@icons/message-icon.component';
import { EmojiSelectComponent } from '../../@components/emoji-select/emoji-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessageCircleQuestionIconComponent } from '../../../@icons/message-circle-question-icon.component';
import { FeedbackApi } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/sdk/feedback/feedback-api';
import { CreateFeedbackRequest } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/requests/feedback/create-feedback.request';

@Component({
  selector: 'vw-feedback-modal',
  imports: [
    CloseBtnComponent,
    SharedModule,
    TranslatePipe,
    CircleUserIconComponent,
    EmojiSelectComponent,
    ReactiveFormsModule,
    FormsModule,
    MessageCircleQuestionIconComponent
  ],
  providers: [FeedbackApi],
  templateUrl: './feedback-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './feedback-modal.component.scss'
})
export class FeedbackModalComponent extends BaseModalComponent implements OnChanges {
  @Input() feedbackType: 'wdyt' | 'dyl' | 'wwyl' | 'comment' = 'wdyt';

  message: string;
  emoji: 'smile' | 'meh' | 'bad' = 'smile';

  constructor(private feedbackApi: FeedbackApi) {
    super();
  }
  ngOnChanges() {
    //TODO - Implement this method
  }

  onEmojiSelected(emoji: 'smile' | 'meh' | 'bad') {
    this.emoji = emoji;
  }

  async createFeedback() {
    try {
      await this.feedbackApi.create({
        type: 'global',
        comment: this.emoji + ' - ' + this.message,
        origin: '/home'
      })
      this.message = '';
      this.close();
    } catch (error) {
      console.error(error);
    }
  }

  onSendButtonClick() {
    this.createFeedback();
  }
}
